import React from 'react';

export default function LightAlert({ children }) {
    return (
        <div className="border-2 border-boxmeal-green-600 py-3 px-4 rounded-2xl">{children}</div>
    );
}
